import { render, staticRenderFns } from "./AddNewScholarshipModal.vue?vue&type=template&id=41784ff1&scoped=true&"
import script from "./AddNewScholarshipModal.vue?vue&type=script&lang=js&"
export * from "./AddNewScholarshipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41784ff1",
  null
  
)

export default component.exports